import { Component, input, computed } from '@angular/core';
import {
  RdsButtonModule,
  RdsDividerModule,
  RdsFormFieldModule,
  RdsIconComponent,
} from '@rds/angular-components';
import { Congress } from '../../models/congress.model';
import { DateFormatter } from '../../models/date-formatter.model';

@Component({
  selector: 'app-congress-detail-view',
  standalone: true,
  imports: [
    RdsButtonModule,
    RdsDividerModule,
    RdsFormFieldModule,
    RdsIconComponent,
  ],
  templateUrl: './congress-detail-view.component.html',
  styleUrl: './congress-detail-view.component.scss',
})
export class CongressDetailViewComponent {
  congressInput = input.required<Congress>({ alias: 'congress' });

  congress = computed(() => {
    const c = this.congressInput();
    if (c instanceof Congress) return c;
    return Object.assign(new Congress(), c);
  });

  get locationText(): string {
    const event = this.congress().milestones.event;
    const parts = [event.city, event.country].filter(Boolean);
    return parts.join(', ');
  }

  formatDate(dateStr: string | null | undefined): string {
    if (!dateStr) return '—';
    return new DateFormatter(new Date(dateStr), false).presentationDate;
  }

  openCallForAbstractsLink(): void {
    const url = this.congress().milestones.abstractDue.callForAbstractUrl;
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }

  openWebsite(): void {
    const url = this.congress().website;
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }
}
